module.exports = __webpack_public_path__ + "static/mouse-left.a487d2346301ad619629c60c2981e4a8.svg";